export type ContentfulStatus = 'draft' | 'changed' | 'published' | 'archived'

/**
 * Derives the Contentful status of an entry based on its `sys` properties.
 *
 * @param sys The sys object from a Contentful Entry
 * @returns 'archived' | 'changed' | 'published' | 'draft'
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getEntryStatus = (sys?: any): ContentfulStatus => {
  if (!sys) return 'draft'

  const firstPublishedAt = sys.firstPublishedAt
  const publishedAt = sys.publishedAt
  const updatedAt = sys.updatedAt
  const archivedAt = sys.archivedAt

  if (archivedAt) {
    return 'archived'
  }

  if (!firstPublishedAt) {
    return 'draft'
  }

  if (updatedAt && publishedAt && new Date(updatedAt) > new Date(publishedAt)) {
    return 'changed'
  }

  return 'published'
}
